import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPasswordRequest } from '../../lib/api/auth';
import {
  AuthError,
  AuthField,
  AuthShell,
  AuthSubmit,
  PasswordStrengthMeter
} from './components/AuthForm';

function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      // LIVE PB confirm-password-reset — contract requires token + password +
      // passwordConfirm. Expired/used/unknown tokens reject with 400 and
      // surface as an invalid-link error (never silently accepted).
      await resetPasswordRequest({ token, password, passwordConfirm: confirm });
      navigate('/login', { replace: true, state: { reset: true } });
    } catch (requestError) {
      setError(requestError.message || 'Unable to reset the password right now.');
      setBusy(false);
    }
  };

  return (
    <AuthShell
      eyebrow="ACCOUNT RECOVERY"
      subtitle={token ? 'Choose a new password for your account.' : 'This link is missing its reset token.'}
      title="Set a new password"
    >
      <form onSubmit={handleSubmit}>
        <AuthField
          autoComplete="new-password"
          id="reset-password"
          label="New password"
          onChange={setPassword}
          type="password"
          value={password}
        />
        <PasswordStrengthMeter password={password} />
        <AuthField
          autoComplete="new-password"
          id="reset-confirm"
          label="Confirm new password"
          onChange={setConfirm}
          type="password"
          value={confirm}
        />
        <AuthError message={error} />
        <AuthSubmit busy={busy}>Update password</AuthSubmit>
      </form>

      <div className="auth-links">
        <Link to="/login">Back to sign in</Link>
        {/* Expired/used token → the reset can't proceed; the re-request path
            stays reachable in every state. */}
        <Link to="/forgot-password">Request a new link</Link>
      </div>
    </AuthShell>
  );
}

export default ResetPasswordPage;
